import styled from "styled-components";

export const BlueLink = styled.a`
  color: ${(props) => props.theme.palette.primary};
`;
